<template>
  <div>
    <v-card
      class="mx-auto my-2 px-4 py-6 body-2"
      :style="
        $vuetify.theme.dark
          ? 'color: rgba(255,255,255,0.7);'
          : 'color: rgba(0,0,0,0.7);'
      "
    >
      <div class="mb-4">
        <h1>
          Webhooks
        </h1>
      </div>
      <div v-html="$t('whatAreWebhooks')"></div>
    </v-card>

    <v-card>
      <v-row
        class="
          d-flex
          justify-end
          align-center
          pa-3
        "
      >
        <v-col cols="12" md="6">
          <CreateWebhook @refresh="fetchWebhooks" />
        </v-col>

        <v-spacer></v-spacer>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="search"
            class="ma-1"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-details
            dense
            solo-inverted
            clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="webhooksList"
        class="elevation-1"
        calculate-widths
        :loading-text="$t('loadingWebhooks')"
        :loading="$store.state.feedbackProgress"
        :search="search"
      >
        <template v-slot:item.endpoint="{ item }">
          <div class="truncate">
            {{ item.endpoint }}
          </div>
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip small :color="handleStatusUI(item.status).color">
            {{ handleStatusUI(item.status).text }}
          </v-chip>
        </template>

        <template v-slot:item.tipo="{ item }">
          {{ items.find(({ value }) => value === item.tipo).text }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn-toggle>
            <ChangeWebhookUrl
              :infos="{
                endpoint: item.endpoint,
                status: item.status,
                webhookId: item.webhook_id,
              }"
              @refresh="fetchWebhooks"
            />
            <ChangeWebhookStatus
              :infos="{
                endpoint: item.endpoint,
                status: item.status,
                webhookId: item.webhook_id,
              }"
              @refresh="fetchWebhooks"
            />
            <TestWebhook
              :infos="{
                endpoint: item.endpoint,
                webhookId: item.webhook_id,
                tipo: item.tipo,
                disabled: !item.status,
              }"
              @refresh="fetchWebhooks"
            />
          </v-btn-toggle>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import ChangeWebhookStatus from "./ChangeWebhookStatus.vue";
import ChangeWebhookUrl from "./ChangeWebhookUrl.vue";
import CreateWebhook from "./CreateWebhook.vue";
import TestWebhook from "./TestWebhook.vue";

export default {
  components: {
    CreateWebhook,
    ChangeWebhookStatus,
    ChangeWebhookUrl,
    TestWebhook,
  },

  data: (vm) => ({
    valid: false,
    url: "",
    type: "",
    search: "",
    switchStatus: false,
    items: [
      {
        text: vm.$t("register"),
        value: "cadastro",
      },
      {
        text: vm.$t("deposit"),
        value: "deposito",
      },
      {
        text: "Login",
        value: "login",
      },
    ],

    headers: [
      {
        text: "URL",
        value: "endpoint",
      },
      {
        text: vm.$t("type"),
        value: "tipo",
        align: "center",
      },
      {
        text: "Status",
        value: "status",
        align: "center",
      },
      {
        text: vm.$t("actions"),
        value: "actions",
        align: "center",
      },
    ],

    webhooksList: [],
    fetchTimeout: 0,
  }),

  mounted() {
    this.fetchWebhooks();
  },

  methods: {
    async fetchWebhooks() {
      const res = await this.$request.get(
        `${this.$prefix()}/WebHook/listWebHooks`
      );

      if (res && res.dados) {
        this.webhooksList = [
          ...res.dados.map((webhook) => ({
            ...webhook,
            status: webhook.status === "Ativo",
          })),
        ];
      } else {
        this.webhooksList = [];
      }
    },

    handleStatusUI(status) {
      if (status) {
        return { text: this.$t("active"), color: "green" };
      } else {
        return { text: this.$t("inactive"), color: "grey" };
      }
    },
  },
};
</script>

<style>
.truncate {
  max-width: 400px;
}
</style>
